import { Header, UserTypes, useTranslation } from '@fareye/common'
import { Flex, Grid, Link, styled } from '@fareye/ui'
import { getOverrideUser, getUserType } from '@fareye/utils'
import React from 'react'
import { IAlerts } from '../../utility/types'

export const SettingsCard = styled(Grid)`
  justify-content: space-evenly;
  padding: 2vw;
  grid-gap: 2vw;
  overflow: hidden;
  transition: 1s ease;
  @media (max-width: 1900px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 19%);
  }
  @media (max-width: 1440px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 24%);
  }
  @media (max-width: 1100px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 32%);
  }
  @media (max-width: 700px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 49%);
  }
  @media (max-width: 400px) {
    transition: 1s ease;
    grid-gap: 2vw;
    grid-template-columns: minmax(0, 1fr);
  }
  @media (min-width: 1901px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 16%);
  }
`

export const CardLink = styled(Link)`
  display: flex;
  align-item: center;
  justify-content: center;
  box-sizing: border-box;
  background: #fff;
  min-height: 150px;
  &:hover {
    background: #fff;
  }
`

export function Settings(props: any) {
  const { match, history, location, routesConfig, config: propsConfig } = props
  const { t } = useTranslation()
  const { config, styling } = propsConfig
  const { bodyBgColor } = styling ? styling : { bodyBgColor: '#f0f2f5' }
  const loggedInUserUniqSubTypes: string[] = React.useMemo(
    () =>
      Array.from(
        new Set(
          routesConfig
            .filter((item: any) => item.subType || item.children)
            .map((item: any) => {
              if (item.children?.length) {
                return item.children.map((item: any) => item.subType)
              }
              return item.subType
            })
            .flat()
        )
      ),
    [routesConfig]
  )
  const isReportSubTypeAllowed = React.useMemo(() => {
    var exist = false
    loggedInUserUniqSubTypes.every(subType => {
      if (subType.toLowerCase().includes('report')) {
        exist = true
        return false
      }
      return true
    })
    return exist
  }, [loggedInUserUniqSubTypes])

  const settingsItems: IAlerts[] = [
    {
      label: 'User Management',
      link: '/settings/user-management',
      order: 1
    }
  ]
  if (UserTypes.Developer === getUserType()) {
    settingsItems.push({
      label: 'Consignment Onboarding',
      link: '/settings/consignment-onboarding',
      order: 2
    })
  }
  if (
    UserTypes.Developer === getUserType() ||
    UserTypes.PA === getOverrideUser()
  ) {
    settingsItems.push({
      label: 'Config Management',
      link: '/settings/config-management',
      order: 4
    })
  }

  // Reports Config available only if
  // * user is allowed reports page
  // * user is developer or admin or account manager
  // * reports link already not pushed
  if ([UserTypes.Developer, UserTypes.Admin].includes(getUserType())) {
    if (
      settingsItems.findIndex(
        (item: any) => item.link === '/settings/tables-config'
      ) < 0 &&
      [UserTypes.Admin].includes(getUserType())
    ) {
      settingsItems.push({
        label: 'Tables Config',
        link: '/settings/tables-config',
        order: 3
      })
    }
    if (
      settingsItems.findIndex(
        (item: any) => item.link === '/settings/reports-config'
      ) < 0 &&
      isReportSubTypeAllowed
    ) {
      settingsItems.push({
        label: 'Reports Config',
        link: '/settings/reports-config',
        order: 2
      })
    }
  }

  return (
    <Flex column width={1} style={{ height: '100%' }}>
      <Header
        match={match}
        location={location}
        history={history}
        routesConfig={routesConfig}
      />
      <div style={{ flexGrow: 1, background: bodyBgColor, overflow: 'hidden' }}>
        <SettingsCard>
          {settingsItems
            .sort((a, b) => a.order - b.order)
            .map((item: IAlerts) => (
              <CardLink key={item.link} to={item.link}>
                {t(item.label)}
              </CardLink>
            ))}
        </SettingsCard>
      </div>
    </Flex>
  )
}
